import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { AdvancedFilterRow, MultiSelectionAdvancedFilter } from 'shared/components/AdvancedFilter';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectConditionTypeFilter } from 'shared/selectors/advancedFilters';
import { EConditionType } from '../../../../../../../packages/JsonQuery/types/conditionType';
import { NonEmptyArray } from '../../../../../../../packages/JsonQuery';

export const ConditionTypeContainer: FC = () => {
  const { label, value, options } = useSelector(selectConditionTypeFilter);

  const onChange = useFilterChangeCallback();

  const handleConditionTypeChange = useCallback(
    (newValue: NonEmptyArray<EConditionType> | null) => {
      onChange({ action: 'setConditionType', arguments: [newValue] });
    },
    [onChange],
  );

  return (
    <AdvancedFilterRow label={label}>
      <MultiSelectionAdvancedFilter value={value} options={options} onFilterChange={handleConditionTypeChange} />
    </AdvancedFilterRow>
  );
};
